import HttpClient from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';
// @deprecated inbounddb-objects is not available in internal auth (as of 1/16/25) Please use GET_CRM_SEARCH_OBJECT instead
export const GET_CRM_OBJECT = registerQuery({
  fieldName: 'crmObject',
  args: ['portalId', 'objectTypeId', 'objectId'],
  fetcher({
    portalId,
    objectTypeId,
    objectId
  }) {
    return HttpClient.get(`inbounddb-objects/v1/crm-objects/${objectTypeId}/${objectId}`, {
      query: {
        portalId,
        includeAllValues: true,
        includeAllProperties: true,
        allPropertiesFetchMode: 'all_versions'
      }
    });
  }
});
export const GET_OBJECT_TYPE_PROPERTIES = registerQuery({
  fieldName: 'objectProperties',
  args: ['portalId', 'objectTypeId'],
  fetcher({
    portalId,
    objectTypeId
  }) {
    return HttpClient.get(`properties/v4/${objectTypeId}`, {
      query: {
        portalId,
        includeProperties: true
      }
    });
  }
});
const getSpecialCasedReferenceType = referenceType => {
  // Some of the reference types on the property definitions don't map to the same string
  // on the external options BE. This takes care of that mapping functionality, but hopefully
  // these reference types will just get updated to be accurate at some point..

  if (referenceType === 'DEAL_STAGE' || referenceType === 'TICKET_STAGE') {
    return 'PIPELINE_STAGE';
  }
  if (referenceType === 'DEAL_PIPELINE' || referenceType === 'TICKET_PIPELINE') {
    return 'PIPELINE';
  }
  return referenceType;
};
export const GET_EXTERNAL_OPTIONS_BY_IDS = registerQuery({
  fieldName: 'externalOptionsByIds',
  args: ['portalId', 'referenceType', 'ids', 'objectTypeId'],
  fetcher({
    portalId,
    referenceType,
    objectTypeId,
    ids
  }) {
    const referenceTypeToRequest = getSpecialCasedReferenceType(referenceType);
    return HttpClient.post(objectTypeId ? `external-options/v2/fetch/${objectTypeId}/${referenceTypeToRequest}` : `external-options/v2/fetch/${referenceTypeToRequest}`, {
      query: {
        portalId
      },
      data: {
        portalId,
        referenceType: referenceTypeToRequest,
        ids,
        objectTypeId,
        includeDeleted: true,
        includeDisabled: true
      }
    });
  }
});

// Only for contact objects
export const GET_FORM_BY_ID = registerQuery({
  fieldName: 'formById',
  args: ['portalId', 'formId'],
  fetcher({
    portalId,
    formId
  }) {
    return HttpClient.get(`forms/v2/forms/${formId}`, {
      query: {
        portalId
      }
    });
  }
});
export const GET_NAME_FOR_IMPORT_ID = registerQuery({
  fieldName: 'nameForImportId',
  args: ['portalId', 'importId'],
  fetcher({
    portalId,
    importId
  }) {
    return HttpClient.put('inbounddb-io/imports/get-names', {
      query: {
        portalId
      },
      data: [importId]
    });
  }
});

// Chatflow APIs don't support internal auth for some reason, so this was the only alternative I could think of
// to get around that restriction via crm-search 🤷
export const GET_CHATFLOW_BY_ID = registerQuery({
  fieldName: 'chatflowById',
  args: ['portalId', 'chatflowId'],
  fetcher({
    portalId,
    chatflowId
  }) {
    return HttpClient.post('crm-search/search', {
      query: {
        portalId
      },
      data: {
        portalId,
        objectTypeId: '0-56',
        count: 1,
        offset: 0,
        filterGroups: [{
          filters: [{
            operator: 'EQ',
            property: 'hs_chatflow_id',
            value: chatflowId
          }]
        }],
        requestOptions: {
          allPropertiesFetchMode: 'latest_version'
        }
      }
    });
  }
});
export const GET_CRM_SEARCH_OBJECT = registerQuery({
  fieldName: 'crmSearch',
  args: ['portalId', 'objectTypeId', 'query'],
  fetcher({
    portalId,
    objectTypeId,
    query
  }) {
    const commonBodyParams = {
      portalId,
      objectTypeId,
      count: 50,
      offset: 0,
      sorts: [{
        property: 'createdate',
        order: 'DESC'
      }],
      requestOptions: {
        allPropertiesFetchMode: 'latest_version'
      },
      nextCursor: null
    };

    // We need two separate calls here- one to fetch by object search properties and one for exact objectId match
    // See https://hubspot.slack.com/archives/CHSNBCG79/p1667238945207749
    const searchByQuery = HttpClient.post('crm-search/search', {
      query: {
        portalId
      },
      data: Object.assign({
        query
      }, commonBodyParams)
    });
    const searchByObjectId = HttpClient.post('crm-search/search', {
      query: {
        portalId
      },
      data: Object.assign({
        filterGroups: [{
          filters: [{
            operator: 'EQ',
            property: 'hs_object_id',
            value: query
          }]
        }]
      }, commonBodyParams)
    });
    return Promise.allSettled([searchByQuery, searchByObjectId]).then(([searchByQueryResult, searchByObjectIdResult]) => {
      const seenObjectIds = new Set();
      const mergedResults = {
        results: [],
        hasMore: false,
        offset: 0,
        total: 0
      };
      if (searchByQueryResult.status === 'fulfilled') {
        mergedResults.results.push(...searchByQueryResult.value.results);
        // Keep track of added objects as to not introduce duplicates
        searchByQueryResult.value.results.forEach(obj => seenObjectIds.add(obj.objectId));
        mergedResults.hasMore = searchByQueryResult.value.hasMore;
        mergedResults.offset = searchByQueryResult.value.offset;
        mergedResults.total = searchByQueryResult.value.total;
      }
      if (searchByObjectIdResult.status === 'fulfilled') {
        searchByObjectIdResult.value.results.forEach(obj => {
          if (!seenObjectIds.has(obj.objectId)) {
            mergedResults.results.push(obj);
          }
        });
        mergedResults.hasMore = mergedResults.hasMore || searchByObjectIdResult.value.hasMore;
        mergedResults.offset = mergedResults.offset + searchByObjectIdResult.value.offset;
        mergedResults.total = mergedResults.total + searchByObjectIdResult.value.total;
      }

      // Filter out duplciates

      return mergedResults;
    });
  }
});
export const CRM_SEARCH_BY_ID_FIELD_NAME = 'flowDoctorLibCrmSearchById';
export const GET_CRM_SEARCH_OBJECT_BY_ID = registerQuery({
  fieldName: CRM_SEARCH_BY_ID_FIELD_NAME,
  args: ['portalId', 'objectTypeId', 'objectId'],
  fetcher({
    portalId,
    objectTypeId,
    objectId
  }) {
    const commonBodyParams = {
      portalId,
      objectTypeId,
      count: 10,
      offset: 0,
      sorts: [{
        property: 'createdate',
        order: 'DESC'
      }],
      requestOptions: {
        allPropertiesFetchMode: 'latest_version'
      },
      nextCursor: null
    };
    return HttpClient.post('crm-search/search', {
      query: {
        portalId
      },
      data: Object.assign({
        filterGroups: [{
          filters: [{
            operator: 'EQ',
            property: 'hs_object_id',
            value: objectId
          }]
        }]
      }, commonBodyParams)
    });
  }
});